import Login from '../../views/pages/Login';

export default [{
  path: '/account',
  name: 'Account',
  component: Login,
  routes: [{
    path: '/login',
    name: 'Account Login',
  }],
}];
